module.exports = __webpack_public_path__ + "img/Refresh - Blue - Selected.caea3f51.png";